
import Vue from "vue";
import { HumanFilter } from "@/utils/human-filter";
import { SaleType } from "@/models/base";
import { SaleService } from "@/services/sale-service";
import AppSaleTypeSelect  from "@/components/sales/SaleTypeSelect.vue";
import { ISelectItem } from "winfakt-vue-components";

export default Vue.extend({
	data(){
		return {
			saleTypes: [] as SaleType[],
			selectedValue: 0,
		};
	},
	props: {
		value: {
			type: Object as ()=>HumanFilter,
			required: true
		},
		ignoredTypeIds: {
			type: Array as () => number[],
			default: () => []
		}
	},
	computed: {
		operators():ISelectItem<string>[]{
			return [
				{
					text: this.$ct("common.filters.is"),
					value: ""
				},
				{
					text: this.$ct("common.filters.is not"),
					value: "not"
				}
			];
		},
		label():string{
			return this.$ct("type-choose").toString();
		},
	},
	methods: {
		onChange(typeID: number) {
			this.value.Values = [`${typeID}`];
			this.selectedValue = typeID;
		},
		setOperator(value:string) {
			this.$set(this.value.Options, 0, value);
		}
	},
	async mounted(){
		this.saleTypes = SaleService.getTypes();
		let ids = this.value.Values.map(v=>parseInt(v || "0")).filter(id=>!Number.isNaN(id) && id != 0);
		if (ids.length == 0) {
			this.value.Values = [`${this.saleTypes[0].ID}`];
			return;
		};
		this.selectedValue = parseInt(this.value.Values[0]);
	},
	components: {
		AppSaleTypeSelect
	},
	i18nEx: {
		componentPrefix: "components.sales",
	}
});
